import React, { useState } from "react"
import PropTypes from 'prop-types'
import Button from 'react-bootstrap/Button'
import 'reactjs-popup/dist/index.css'

import { Translate } from "../Translator"

const TelephonySettingsMetaswitch = (props) => {

    const mSettingsFixed = props.PhoneSettings["$Fixed"] === "y"
    const [mUrl, SetUrl] = useState(props.PhoneSettings["Url"]) 
    const [mExtension, SetExtension] = useState(props.PhoneSettings["Extension"]) 
    const [mPassword, SetPassword] = useState(props.PhoneSettings["Password"])  

    const UpdateSettings = () => {
        props.PhoneSettings["Url"] = mUrl
        props.PhoneSettings["Extension"] = mExtension
        props.PhoneSettings["Password"] = mPassword
        props.OnUpdatePhoneSettings()
    }    

    if (mSettingsFixed)
    {
        return (
            <span>
                <div className="smalltext">{Translate("Extension")}: {mExtension}</div>
            </span>
        )
    }
    else
    {
        return (
            <span>
                <table width="100%" cellPadding={4} className="smalltext">
                <tbody>
                <tr>
                    <td>{Translate("Extension")}</td>
                    <td><input autoComplete="metaswitch.extension" value={mExtension} type="text" onChange={(event) => { SetExtension(event.target.value) }} style={{ width: "300px"}}/></td>
                </tr>
                <tr>
                    <td>{Translate("Password")}</td>
                    <td><input autoComplete="metaswitch.password" value={mPassword} type="text" onChange={(event) => { SetPassword(event.target.value) }} style={{ width: "300px"}}/></td>
                </tr>
                <tr>
                    <td>{Translate("URL")}</td>
                    <td><input autoComplete="metaswitch.url" value={mUrl} type="text" onChange={(event) => { SetUrl(event.target.value) }} style={{ width: "300px"}}/></td>
                </tr>
                </tbody>
                </table>
                {mExtension !== props.PhoneSettings["Extension"] || mPassword !== props.PhoneSettings["Password"] || mUrl !== props.PhoneSettings["Url"] ? <Button variant="primary" onClick={() => UpdateSettings()}>{Translate("Update settings")}</Button> : <Button variant="secondary" disabled>{Translate("Update settings")}</Button>}
            </span>
        )
    }
}

TelephonySettingsMetaswitch.propTypes = {
    PhoneSettings: PropTypes.object,
    OnUpdatePhoneSettings: PropTypes.func
}

export default TelephonySettingsMetaswitch